import React from 'react'
import clsx from 'clsx'

interface RichTextProps {
    content?: string
    hasMargin?: boolean
    children?: React.ReactNode
}

export default function RichText({ content, hasMargin = false, children }: RichTextProps) {

    // add class "has-margin" if hasMargin prop is true
    const hasMarginClass = clsx({ 'rich-text--has-margin': hasMargin })

    return (
        <>
            {content &&
                <div
                    className={clsx('rich-text', hasMarginClass)}
                    dangerouslySetInnerHTML={{ __html: content }}
                    suppressHydrationWarning
                />
            }

            {children &&
                <div className={clsx('rich-text', hasMarginClass)}>
                    {children}
                </div>
            }
        </>
    )
}